import App from './App.svelte';
import './styles/global.css';

const app = new App({
	target: document.querySelector('#app'),

});

export default app;